import { render } from "./ProductNewPage.vue?vue&type=template&id=1f08d1d8&ts=true"
import script from "./ProductNewPage.vue?vue&type=script&lang=ts"
export * from "./ProductNewPage.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\DDrive\\DeveloperFolder\\VueJsApps\\byihusemanagt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__